// removed by extract-text-webpack-plugin
module.exports = {"row":"LegalLinks-style__row__1a5e4630","item":"LegalLinks-style__item__1a5e4630","link":"LegalLinks-style__link__1a5e4630"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LinkRow/LegalLinks-style.scss
// module id = ./src/components/Footer/LinkRow/LegalLinks-style.scss
// module chunks = 13